
const menuDefault = {
    groupTitleFontSize: 12,
}

export const menuLite = {
    ...menuDefault,
    itemSelectedBg: 'rgba(237, 240, 255, 1)',
    groupTitleColor: 'rgba(152, 152, 152, 1)',
}

export const menuDark = {
    ...menuDefault,
}